import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'

const ContactPage = () => {

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    script.setAttribute('type', 'text/javascript');
    document.body.appendChild(script);

    script.addEventListener('load', () => {
        //@ts-ignore
        if(window.hbspt){
            //@ts-ignore
            hbspt.forms.create({
            region: "na1",        
            portalId: "23399414",        
            formId: "24811d46-877f-4345-8f09-f39f01d19d89",
            target: '#hubspotForm'
          });
        }
    });

    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }

  }, [])

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        CONTACT US
      </PageTitle>
      <div className='card bg-white min-h-750px' style={{border: 'solid 1px #E8E8E8'}}>
      <div className='card-header pt-3 pb-2 d-flex align-items-center'>
        <h3 className='card-title align-items-start flex-row'>
          <span className='card-label fw-light fs-3 text-primary'>Contact Us</span></h3>
      </div>

      <div className='card-body py-6'>
      <p>
      if you have any questions or would like to learn more on how MaestroXConnect can support your business growth, please email us on <a href="mailto:support@Maestrox.com">support@MaestroX.com</a> of via the form below.
      </p>
      <p>To request portal access for additional user at your organization, please include the First name + Last name + email address of each user in the message box below:
      </p>
      <div id="hubspotForm"></div>
      </div>
    </div>
    </>
  )
}

const ContactWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>CONTACT US</PageTitle>
      <ContactPage />
    </>
  )
}

export {ContactWrapper}
